import { useMutation, useQueryClient } from '@tanstack/react-query';
import { customiseDocumentTemplate } from '../services/documentTemplates';
import type { CustomiseTemplateInput } from '../types/documentTemplates.types';
import { documentTemplateKeys } from './documentTemplateKeys';

export const useCustomiseTemplateMutation = (sourceTemplateId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: CustomiseTemplateInput) => customiseDocumentTemplate(sourceTemplateId, input),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: documentTemplateKeys.lists() }),
  });
};
